export default __webpack_public_path__ + "static/media/simulate-cyber-icon.3b764c7c.png";